import { render, staticRenderFns } from "./option-trade.vue?vue&type=template&id=5006454b&scoped=true"
import script from "./option-trade.vue?vue&type=script&lang=js"
export * from "./option-trade.vue?vue&type=script&lang=js"
import style0 from "./option-trade.vue?vue&type=style&index=0&id=5006454b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5006454b",
  null
  
)

export default component.exports